<template>
  <!-- <div class="search-header">
    <van-search v-model="value" show-action :placeholder="keyName" @search="onSearch" @cancel="onCancel" />
    <img class="filter" src="@/assets/imgs/product_filter.png" @click="onFilter" />
  </div>
 -->
  <div class="price-search">
    <van-search v-model="value" :placeholder="keyName" @search="onSearch" :clearable="false">
      <template #left-icon>
        <img src="@/assets/imgs/搜索@3x.png" alt="" style="display: none;">
      </template>
      <template #right-icon>
        <img src="@/assets/imgs/搜索@3x.png" alt="" @click="onSearch">
      </template>
    </van-search>
  </div>
</template>

<script>
export default {
  name: "Search",
  data() {
    return {
      value: '',
    };
  },
  props: {
    keyName: String,
  },
  computed: {},
  methods: {
    onFilter() {
      this.$emit("onFilter");
    },
    onSearch(val) {
      console.log(val)
      this.$emit("onSearch",val)
    },
    onCancel() {
     
    },
  }
};
</script>

<style lang="stylus" scoped>
.search-header >>> .van-search {
  width: 90%;
}

.search-header >>> .van-field__control, .search-header >>> .van-field__left-icon {
  height: 40px;
  line-height: 40px;
}

.search-header {
  height: 88px;
  background: rgba(244, 244, 244, 1);
  padding: 0 22px 0 34px;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  .center {
    font-size: 36px;
    font-weight: 600;
    color: rgba(34, 34, 34, 1);
    flex: 1;
    text-align: center;
  }

  .back {
    width: 24.83px;
    height: 45.66px;
  }

  .filter {
    width: 40px;
    height: 40px;
  }
}
</style>

<style lang="stylus" scoped>
.price-search {
  padding: 0 32px;
  margin: 30px 0;

  >>> .van-search {
    width: 100%;
    height: 72px;
    background: #FFFFFF;
    border-radius: 36px 36px 36px 36px;
  }

  >>> .van-search__content {
    border-radius: 36px 36px 36px 36px;
  }

  >>> .van-field__control {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 24px;
    color: #999999;
  }

  >>> .van-field__right-icon {
    img {
      width: 32px;
      height: 32px;
    }
  }
}
</style>

